export function buildChatThemeCssVars(themeTokens = {}) {
  return {
    '--flare-accent': themeTokens.bubbleUserBg,
    '--flare-accent-hover': themeTokens.surfaceBorderActive,
    '--flare-focus-outline': themeTokens.focusOutline,
    '--flare-font-body': themeTokens.fontFamilyBody,
    '--flare-font-heading': themeTokens.fontFamilyHeading,
    '--flare-hover-bg': themeTokens.surfaceBgActive,
    '--flare-scrollbar-thumb': themeTokens.divider,
    '--flare-divider': themeTokens.divider,
    '--flare-panel-bg': themeTokens.panelBg,
    '--flare-sidebar-bg': themeTokens.sidebarBg,
    '--flare-surface-bg-active': themeTokens.surfaceBgActive,
    '--flare-surface-border-active': themeTokens.surfaceBorderActive,
    '--flare-text-primary': themeTokens.textPrimary,
    '--flare-text-secondary': themeTokens.textSecondary,
  };
}
